import {Company,UserCompany} from '../companies';
import {Partner} from './partner';

export interface User {
  id: number;
  email: string;
  roleId: number;
  partnerId: number;
  companies: Company[];
  partner: Partner;
  userCompanies?: UserCompany[];

  // Campos de utils solo de frontend
  viewAdministracion: boolean;
  viewMaestros: boolean;
  viewOnlyDriversEquipmentsMaestros: boolean;
  viewMoneyData: boolean;
  viewUnassignedProjectsAndServices: boolean;
  editProject: boolean;
  createContainers: boolean;
  editService: boolean;
  generateOrders: boolean;
  validateOrders: boolean;
  emitAndSendOrders: boolean;
  reviewOrders: boolean;
  approveOrders: boolean;
  uploadDocumentsUnlimited: boolean;
  validateDocuments: boolean;
  uploadDocumentsLimited: boolean;
  editSOLimited: boolean;
  editSOUnlimited: boolean;
  viewAndEditTransportSectionSO: boolean;
  createProject: boolean;
  createService: boolean;
}

export interface UserCreate {
  email: string;
  roleId: number;
  partnerId: number;
}


export interface UserCreate {
  email: string;
  roleId: number;
  partnerId: number;
}

export interface UserRole {
  id: number;
  name: string;
}
